import type { RouteInterface } from '@/src/common/enums/routes'

export const Routes = {
  Mortgage: {
    route: '/main/(tabs)/home/mortgage',
    name: 'Mortgage',
    availableForDeepLinking: true,
    aliases: ['/main/mortgage'],
  },
} as const satisfies Record<string, RouteInterface>
